module.exports = __webpack_public_path__ + "img/proList2_27_03.17088fc1.jpg";